import type { HealthDocumentTypeId, HealthDocument } from 'leash/types';

export const getLatestDocumentForType = (
  documents: HealthDocument[],
  documentType: HealthDocumentTypeId,
): HealthDocument | null => {
  return (
    documents
      ?.filter((doc) => doc.documentTypeId === documentType)
      ?.sort((a, b) =>
        // ISO-8601 sorts lexicographically.
        a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0,
      )?.[0] ?? null
  );
};
